import React from "react";


const getStatusClass = (
    status
) => {

    const value =
        String(
            status ||
            ""
        )
            .trim()
            .toUpperCase();


    switch (
        value
    ) {

        case "ACTIVE":
            return "platform-business-status-active";

        case "TRIAL":
            return "platform-business-status-trial";

        case "SUSPENDED":
            return "platform-business-status-suspended";

        case "INACTIVE":
            return "platform-business-status-inactive";

        case "EXPIRED":
            return "platform-business-status-expired";

        default:
            return "platform-business-status-default";

    }

};


const BusinessStatusBadge = ({
    status,
    fallback = "-",
}) => {

    const value =
        String(
            status ||
            ""
        )
            .trim()
            .toUpperCase();


    return (

        <span
            className={`platform-business-status ${getStatusClass(
                value
            )}`}
        >

            {
                value ||
                fallback
            }

        </span>

    );

};


export default BusinessStatusBadge;